var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoreSellerForm',{attrs:{"title":_vm.$t('store-sellers.create.title'),"action":_vm.createSeller,"success-msg":_vm.$t('store-sellers.create.success'),"error-msg":_vm.$t('store-sellers.create.error')},on:{"next":_vm.onCreated}})
}
var staticRenderFns = []

export { render, staticRenderFns }